export const NotificationsType = {
  Maintenance: 1,
  SpinResponseCode: 2,
  InsufficientAmount: 3,
};
